import React from "react";
import PropTypes from "prop-types";
import HorizontalStackBar from "../../HorizontalStackBar/HorizontalStackBar";

function SingleServiceStatsBar({
  serviceData,
  againstPlayerStats = [],
  isFirstService = true,
}) {
  let positiveValue = 0;
  let neutralValue = 0;
  let negativeValue = 0;
  if (isFirstService) {
    positiveValue =
      serviceData.service.acesOnFirstService +
      serviceData.service.pointsOnFirstService;
    neutralValue = serviceData.service.firstServicesStartedRallies;
    negativeValue = serviceData.service.faults;
    againstPlayerStats.forEach((player) => {
      negativeValue += player.stats.serviceResponse.firstService.returnWinners;
      positiveValue +=
        player.stats.serviceResponse.firstService.returnErrors +
        player.stats.serviceResponse.firstService.returnForcedErrors;
    });
  } else {
    positiveValue =
      serviceData.service.acesOnSecondService +
      serviceData.service.pointsOnSecondService;
    neutralValue = serviceData.service.secondServicesStartedRallies;
    negativeValue = serviceData.service.doubleFaults;
    againstPlayerStats.forEach((player) => {
      negativeValue += player.stats.serviceResponse.secondService.returnWinners;
      positiveValue +=
        player.stats.serviceResponse.secondService.returnErrors +
        player.stats.serviceResponse.secondService.returnForcedErrors;
    });
  }

  const data = [
    {
      label: "Positiva",
      value: positiveValue,
      backgroundColor: "#5cb85c",
    },
    {
      label: "Neutra",
      value: neutralValue,
      backgroundColor: "#062a40",
    },
    {
      label: "Negativa",
      value: negativeValue,
      backgroundColor: "#d9534f",
    },
  ];
  return (
    <HorizontalStackBar
      labels={["Servizio"]}
      data={data}
      title="Efficacia colpi"
    />
  );
}

SingleServiceStatsBar.propTypes = {
  serviceData: PropTypes.object.isRequired,
  againstPlayerStats: PropTypes.arrayOf(PropTypes.object),
  isFirstService: PropTypes.bool,
};

export default SingleServiceStatsBar;
